exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--cardTabs__yPX1J{font-size:15px;margin-top:-14px;margin-bottom:14px}.block_title .styles--cardTabs__yPX1J{margin:-17px -13px -19px -13px;padding:0 13px;border:none}.styles--cardTabsSwitcher__3czn-{padding:0}\n", ""]);

// exports
exports.locals = {
	"cardTabs": "styles--cardTabs__yPX1J",
	"cardTabsSwitcher": "styles--cardTabsSwitcher__3czn-"
};